import { Button, Card, Tooltip } from "@jhool-io/fe-components";
import InfoIcon from "../../../../icons/Info";

interface BillingSummayCardProps {
    /** Card background color */
    bgColor: string;
    /** Card title */
    title: string;
    /** Tooltip information text */
    tooltipDescription: string;
    /** Card description */
    description: string;
    /** Count of items in count */
    count: string | number;
    /** Small count text */
    smallCount?: string | number;
    /** Card list */
    list?: React.ReactElement;
    /** Should card list be hidden */
    showList?: boolean;
    /** Should card be hidden */
    hide?: boolean;
}

export default function BillingSummaryCard({
    bgColor,
    title,
    tooltipDescription,
    description,
    count,
    smallCount,
    list,
    hide,
    showList = true,
}: BillingSummayCardProps) {
    if (hide) return null;

    return (
        <Card style={{ backgroundColor: bgColor }}>
            <div className="flex flex-col max-w-full overflow-y-auto text-nowrap h-full overflow-x-auto">
                <div className="flex items-center gap-x-2 mb-[--spacing-items]">
                    <h3 className="text-base font-bold">{title}</h3>
                    <Tooltip content={tooltipDescription}>
                        <Button size="auto" variant="normal">
                            <InfoIcon className="size-3" />
                        </Button>
                    </Tooltip>
                </div>
                <span className="text-text opacity-70 font-medium mb-2 text-caption">
                    {description}
                </span>
                <span className="text-titleLg font-extrabold">
                    {count}
                    {smallCount && (
                        <span className="text-caption font-medium whitespace-nowrap">{` / ${smallCount}`}</span>
                    )}
                </span>
                {showList && (
                    <div className="mt-[--spacing-header]">{list}</div>
                )}
            </div>
        </Card>
    );
}
